module.exports = __webpack_public_path__ + "34736292/img/note-list-icon.961c1485.svg";